/** The path segment of an install item's page in the frontend router.
 *
 * React Router 6.10 decodes the location before matching it, then decodes the
 * matched param again, so a plain `encodeURIComponent` would open item `A`
 * for the item `%41`. Encoding `%` a second time survives both decodes.
 * (The first decode leaves reserved characters such as `%2F` encoded, so only
 * `%` needs the extra round.)
 *
 * TODO: Upgrade React Router to 6.22+, which decodes params once, and use
 * `encodeURIComponent` instead.
 */
export const itemRouteSegment = (id: string) =>
  encodeURIComponent(id).replace(/%25/g, "%2525");
